import React, { Component } from 'react';
import PanelHolder from '../model/PanelHolder.js';
import { listenTo, clearBindings, needsApproval } from '../util/Utility.js';
import moment from 'moment';

export default class ApprovalView extends Component {

  constructor(props) {
    super(props)

    this.announcements = [];
    this.events = [];
    this.events2 = [];
  }

  fetchObjects(limit, callback) {
    switch (this.props.type) {

      case "approval1":
        listenTo("events", this, callback, {
          orderByChild: 'atCCO',
          equalTo: true,
          limitToLast: limit
        }, e => !e.approval1 && e.date > moment().unix())
        break;

      case "approval2":
        listenTo("announcements", this, data => {
          this.announcements = data;
          callback(this.announcements.concat(this.events).concat(this.events2))
        }, {
          orderByChild: 'ministryID',
          equalTo: "cco",
          limitToLast: limit
        }, item => !item.approval2 && item.expires > moment().unix())

        listenTo("events", this, data => {
          this.events = data;
          callback(this.events.concat(this.announcements).concat(this.events2))
        }, {
          orderByChild: 'ministryID',
          equalTo: "cco",
          limitToLast: limit
        }, item => !item.approval2 && (item.atCCO ? item.approval1 : true) && item.date > moment().unix())

        listenTo("events", this, data => {
          this.events2 = data;
          console.log(data);
          callback(this.events2.concat(this.announcements).concat(this.events))
        }, {
          orderByChild: 'wholeChurch',
          equalTo: true,
          limitToLast: limit
        }, item => !item.approval2 && (item.atCCO ? item.approval1 : true) && item.date > moment().unix())

        break;

      case "approval3":
        listenTo("events", this, callback, {
          orderByChild: 'date',
          startAt: moment().startOf('day').unix(),
          limitToLast: limit
        }, item => !item.approval3 && item.techSetup)
        break;

      case "approval4":
        listenTo("events", this, callback, {
          orderByChild: 'date',
          startAt: moment().startOf('day').unix(),
          limitToLast: limit
        }, item => {
          let approvalsNeeded = needsApproval(item);
          return !item.approval4 && approvalsNeeded && approvalsNeeded.indexOf("approval4") !== -1 && (approvalsNeeded.indexOf("approval3") === -1 || item.approval3) && (approvalsNeeded.indexOf("approval2") === -1 || item.approval2) && (approvalsNeeded.indexOf("approval1") === -1 || item.approval1);
        })
        break;

      default:
        callback(null);
    }

  }

  componentWillUnmount() {
    clearBindings();
  }

  render() {

    let title = "";
    let description = "";

    switch (this.props.type) {
      case "approval1":
        title = "Availability Approval";
        description = "These events are taking place at the church.  Only approve if the church is available to host events on the requested day AND the room they are requesting to be in is available at the listed time.";
        break;
      case "approval2":
        title = "Validity Approval";
        description = "These events and announcements are going to be shown to the whole church; make sure that the description and content are appropriate.";
        break;
      case "approval3":
        title = "Technical Approval";
        description = "These events need technical setup beyond what is already in the room; only approve if the equipment is available to be used at the requested time.";
        break;
      case "approval4":
        title = "Final Approval";
        description = "These events have been approved, and now just need a final look-over before being published."
    }

    return ( <center>
      <h3>{title}</h3>
      <p style={{maxWidth: 500}}>{description}</p>
      <PanelHolder approval fetchObjects={this.fetchObjects.bind(this)} {...this.props} />
    </center> );
  }
}



/** WEBPACK FOOTER **
 ** ./src/approvals/ApprovalView.js
 **/